import { IUser } from '@reverbdotcom/commons/src/components/user_context_provider';
import experiments from '@reverbdotcom/commons/src/experiments';
import { isExperimentEnabled } from '@reverbdotcom/commons/src/user_context_helpers';

export function boostedUserCountryCode(user: Partial<IUser>) {
  if (isExperimentEnabled(user, experiments.BOOST_MARKETPLACE_SELLER_LOCATION) && !!user.countryCode) {
    return user.countryCode;
  }

  return '';
}
